/**
 * ProjectRiskService
 * Service for ProjectRisk entity operations
 * Route: api/project-risks
 * Controller: ProjectRiskController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectRiskService
 * Handles project risk CRUD operations
 * Maps to /api/project-risks endpoint
 */
export class ProjectRiskService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectRiskService.DEFAULT_SERVICE_PATH,
            basePath: ProjectRiskService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectRiskService.DEFAULT_SERVICE_PATH = 'projects';
ProjectRiskService.BASE_PATH = 'api/project-risks';
//# sourceMappingURL=ProjectRiskService.js.map